import SubHeaders from '@/components/Headers/SubHeaders'
import { useQueryWithHandler } from '@/hooks/useQueryWithHandler'
import { generatePathDatacentral, paths } from '@/utils/path'
import { useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { getPromoById } from '../../services'
import { QUERY_KEYS } from '@/constants/reactQueryKeys'
import useTabs from '@/hooks/useTabs'
import { Tabs } from 'vnetwork-ui'
import { tabs } from './tabs'

const Detail = () => {
    const { t } = useTranslation()
    const { id } = useParams()

    const {
        data: promo,
        renderState,
        refetch,
    } = useQueryWithHandler({
        queryKey: [QUERY_KEYS.PROMOS, 'detail', id],
        queryFn: () => getPromoById(Number(id)),
    })

    const { TabProps, TabComponent } = useTabs({
        tabs: tabs({
            t,
            promo: promo?.result,
            promoId: Number(id),
            refetch,
        }),
    })

    const stateComponent = renderState()
    if (stateComponent) return stateComponent

    return (
        <div>
            <SubHeaders
                actions={[]}
                breadcrumbs={[
                    {
                        path: paths.promosList,
                        title: t('promo_manager'),
                    },
                    {
                        path: generatePathDatacentral(paths.promoDetail, {
                            id: id || '',
                        }),
                        title: promo?.result?.code || '',
                    },
                ]}
            />

            <div className="bg-white rounded-md mt-2">
                <Tabs {...TabProps} tabContainerClassName="pt-0" />
            </div>

            {TabComponent}
        </div>
    )
}

export default Detail
